import React from "react";
import { Box } from "arkh";

export function ResponseWrapper(props: { children: React.ReactNode }) {
  return <Box space="medium">{props.children}</Box>;
}
